import React from "react";
import styled from "styled-components";
import { Tabs, TabButton } from "../../../styles/shared";

const Wrapper = styled(Tabs)`
  border-bottom: none;
  background: ${({ theme }) => theme.surfaceAlt};
  border-radius: 999px;
  padding: 4px;
  gap: 0;
`;

const PillTab = styled(TabButton)`
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  background: ${({ theme, $active }) =>
    $active ? theme.surface : "transparent"};
  border-bottom: none;
  color: ${({ theme, $active }) =>
    $active ? theme.textPrimary : theme.textSecondary};
  margin-bottom: 0;
  box-shadow: ${({ $active }) =>
    $active ? "0 1px 4px rgba(0,0,0,0.08)" : "none"};
`;

const OPCOES = [
  { id: "simples", label: "Simplificado" },
  { id: "avancado", label: "TOC avançado" },
];

export default function ModeToggle({ modo, onChange }) {
  return (
    <Wrapper role="tablist" aria-label="Modo de visualização">
      {OPCOES.map((opcao) => (
        <PillTab
          key={opcao.id}
          $active={modo === opcao.id}
          aria-selected={modo === opcao.id}
          role="tab"
          type="button"
          onClick={() => onChange(opcao.id)}
        >
          {opcao.label}
        </PillTab>
      ))}
    </Wrapper>
  );
}
